import { useState } from "react";

import { useSession } from "../auth/session";
import { config } from "../config";

/** The seeded staff (api/src/db/seed.ts), for a laptop running AUTH_MODE=dev. */
const DEV_PICKS = [
  ["Agent", "dana.whitfield@tomorrowlife.example"],
  ["Supervisor", "marcus.bell@tomorrowlife.example"],
  ["Admin", "renee.alvarez@tomorrowlife.example"],
] as const;

export function SignIn({ reason }: { reason?: string }) {
  const { signIn } = useSession();
  const [email, setEmail] = useState("");

  return (
    <div className="gate">
      <div className="gate-card">
        <div className="nav-brand">
          <span className="nav-mark">TL</span>
          <div>
            <b>Tomorrow</b>
            <span>CRM</span>
          </div>
        </div>
        <h1>Sign in</h1>
        {reason && (
          <div className="banner banner-ochre" style={{ marginBottom: "var(--s-6)" }}>
            {reason}
          </div>
        )}
        {config.authMode === "oidc" ? (
          <>
            <p>
              Use your Amazon Connect username, the one you sign in to the phone with. We email you
              a one-time code; there is no separate password.
            </p>
            <button className="btn btn-primary btn-lg btn-block" onClick={() => void signIn()}>
              Continue with your Connect username
            </button>
          </>
        ) : (
          <>
            <p>
              Development sign-in. The API must be running with{" "}
              <span className="mono">AUTH_MODE=dev</span>; this screen does not exist in a deployed
              CRM.
            </p>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                void signIn(email);
              }}
            >
              <div>
                <label className="field-label" htmlFor="dev-email">
                  Email of a seeded user
                </label>
                <input
                  id="dev-email"
                  className="field"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="picks">
                {DEV_PICKS.map(([role, address]) => (
                  <button
                    key={address}
                    type="button"
                    className="btn btn-sm"
                    onClick={() => void signIn(address)}
                  >
                    {role}
                  </button>
                ))}
              </div>
              <button
                className="btn btn-primary btn-lg btn-block"
                type="submit"
                disabled={!email.trim()}
              >
                Sign in
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
